import { App } from "./App";
import { Helmet } from "react-helmet";
import { pathOr } from "ramda";
import { getDomain } from "utils";

const getSegmentWriteKey = pathOr("", ["pageContext", "segmentWriteKey"]);
const getMarketingProperties = pathOr({}, [
  "pageContext",
  "marketingProperties",
]);

const getIsProductOnly = pathOr(false, ["configuration", "productOnly"]);

export const Campaign = (props: any) => {
  const campaign = props.data.hasura.campaigns_by_pk;
  const { secondary_color } = campaign.university.configuration;
  const secondary = secondary_color || "#ff5555";
  const segmentWriteKey = getSegmentWriteKey(props);
  const marketingProperties = getMarketingProperties(props);
  const baseDomain = getDomain(campaign);
  const canonicalUrl = `${baseDomain}/${campaign.slug}`;
  const isProductOnly = getIsProductOnly(campaign);
  const htmlLang = campaign.configuration.language || "en";

  return (
    <div style={{ backgroundColor: secondary }}>
      <Helmet
        bodyAttributes={{
          class: `font-body text-black antialiased alt-characters ${
            isProductOnly ? "saas-product" : "marketing-campaign"
          }`,
        }}
        htmlAttributes={{
          lang: htmlLang,
        }}
      ></Helmet>
      <Helmet
        link={[
          { rel: "canonical", href: canonicalUrl },
          {
            rel: "preload",
            href: "/fonts/poppins-v20-latin-700.woff2",
            as: "font",
            type: "font/woff2",
            crossOrigin: "anonymous",
          },
        ]}
      />
      <Helmet
        link={[
          { rel: "canonical", href: canonicalUrl },
          {
            rel: "preload",
            href: "/fonts/ibm-plex-sans-v14-latin-regular.woff2",
            as: "font",
            type: "font/woff2",
            crossOrigin: "anonymous",
          },
        ]}
      />
      <Helmet
        link={[
          { rel: "canonical", href: canonicalUrl },
          {
            rel: "preload",
            href: "/fonts/ibm-plex-sans-v14-latin-700.woff2",
            as: "font",
            type: "font/woff2",
            crossOrigin: "anonymous",
          },
        ]}
      />
      <App
        campaign={campaign}
        segmentWriteKey={segmentWriteKey}
        marketingProperties={marketingProperties}
      />
    </div>
  );
};
